import { cn } from "@/lib/utils";

interface StatBadgeProps {
  icon: React.ReactNode;
  count: number;
  label: string;
  className: string;
}

export function StatBadge({ icon, count, label, className }: StatBadgeProps) {
  return (
    <div
      className={cn(
        "flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wider",
        className,
      )}
    >
      {icon}
      {String(count).padStart(2, "0")} {label}
    </div>
  );
}
